if (!customElements.get('pdp-compact-price')) {
  class PdpCompactPrice extends HTMLElement {
    connectedCallback() {
      this.priceEl = this.querySelector('[data-compact-price]');
      this.mrpEl = this.querySelector('[data-compact-mrp]');
      this.metaEl = this.querySelector('[data-compact-meta]');
      this.savingEl = this.querySelector('[data-compact-saving]');
      this.metaRow = this.querySelector('.price-meta');
      this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';
      this.variants = this.parseVariants();

      this.onVariantClick = this.onVariantClick.bind(this);
      this.onVariantInput = this.onVariantInput.bind(this);
      this.onVariantChange = this.onVariantChange.bind(this);

      document.addEventListener('click', this.onVariantClick);
      document
        .querySelector('form[action="/cart/add"] input[name="id"]')
        ?.addEventListener('change', this.onVariantInput);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
      }

      this.update(this.dataset.variantId);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onVariantClick);
      document
        .querySelector('form[action="/cart/add"] input[name="id"]')
        ?.removeEventListener('change', this.onVariantInput);
      if (this.unsubscribeVariant) this.unsubscribeVariant();
    }

    parseVariants() {
      const node = this.querySelector('[data-compact-variants]');
      if (!node) return {};
      try {
        const list = JSON.parse(node.textContent);
        const map = {};
        list.forEach((item) => {
          if (item?.id) map[String(item.id)] = item;
        });
        return map;
      } catch (error) {
        return {};
      }
    }

    formatMoney(cents) {
      const value = Math.max(0, Number(cents) || 0) / 100;
      const withDecimals = value.toFixed(2);
      const noDecimals = String(Math.round(value));
      const withComma = withDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const noDecimalsComma = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      const noTrailing = withComma.replace(/\.00$/, '');
      return this.moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimalsComma)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
        .replace(/\{\{\s*amount\s*\}\}/g, noTrailing)
        .replace(/Rs\.?\s*/gi, '₹');
    }

    packMeta(variant) {
      return [variant.title, variant.tablets, variant.duration].filter(Boolean).join(' · ');
    }

    update(variantId) {
      const variant = this.variants[String(variantId)];
      if (!variant || !this.priceEl) return;

      this.dataset.variantId = String(variant.id);
      this.priceEl.textContent = this.formatMoney(variant.price);

      const compare = Number(variant.compare) || 0;
      const onSale = compare > variant.price;
      if (this.mrpEl) {
        this.mrpEl.textContent = onSale ? this.formatMoney(compare) : '';
        this.mrpEl.hidden = !onSale;
      }

      const savingCents = onSale ? compare - variant.price : 0;
      const percent = onSale ? Math.round((savingCents / compare) * 100) : 0;
      if (this.savingEl) {
        this.savingEl.textContent = onSale
          ? `Save ${this.formatMoney(savingCents)} (${percent}%)`
          : '';
        this.savingEl.hidden = !onSale;
      }

      const meta = this.packMeta(variant);
      if (this.metaEl) this.metaEl.textContent = meta;
      if (this.metaRow) this.metaRow.hidden = !meta && !onSale;
    }

    onVariantClick(event) {
      const card = event.target.closest('.custom-variant-card');
      if (!card?.dataset.variantId) return;
      this.update(card.dataset.variantId);
    }

    onVariantInput(event) {
      if (event.target?.value) this.update(event.target.value);
    }

    onVariantChange(event) {
      const variant = event?.data?.variant;
      if (variant?.id) this.update(variant.id);
    }
  }

  customElements.define('pdp-compact-price', PdpCompactPrice);
}
